<template>
  <div class="row" v-if="isReady">
    <div class="col-12">
      <div class="date-range">
        <div>
          <label for="">Start date</label>
          <input class="form-control" type="date" v-model="heatStart">
        </div>
        <div>
          <label for="">End date</label>
          <input class="form-control" type="date" v-model="heatEnd">
        </div>
      </div>

      <div class="table-wrapper">
        <v-table
          :columns="[
            { label: 'Date', field: 'startDate', sortField: 'timestamp' },
            { label: 'Interactions', field: 'interactionsCount' },
            { label: 'Duration (minutes)', field: 'duration', sortField: 'durationMilliseconds' },
          ]"
          :rows="sessions"
          @play="play"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import VTable from '@/components/VTable.vue'
import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: "Heatmaps",

  components: {
    VTable
  },

  data () {
    return {
      isReady: false,
      isShowingRange: false,
      interactions: [],
      heatStart: '',
      heatEnd: ''
    }
  },

  computed: {
    ...mapGetters({
      pages: 'pages',
      livingOptions: 'livingOptions',
      packages: 'packages',
      properties: 'properties',
      navigation: 'navigation',
      subsections: 'subsections',
    }),

    groupBySessionId () {
      return _.groupBy(this.interactions, 'sessionId')
    },

    groupByPageId () {
      return _.groupBy(this.interactions, 'pageUrl')
    },

    sessions () {
      const uniqueSessions = _.uniqBy(this.interactions, 'sessionId')

      return uniqueSessions.map(session => {
        const interactionsCount = this.groupBySessionId[session.sessionId].length
        const sessionStart = session.timestamp
        const sessionEnd = this.groupBySessionId[session.sessionId][interactionsCount - 1].timestamp
        const milliseconds = sessionEnd - sessionStart

        const minutes = Math.floor(moment.duration(milliseconds, 'milliseconds').asMinutes())
        const seconds = Math.floor(moment.duration(milliseconds, 'milliseconds').asSeconds() % 60)

        return {
          ...session,
          startDate: moment(session.timestamp).utcOffset('+09:30').format('h:mm a Do MMM, YYYY'),
          interactionsCount: interactionsCount,
          timestamp: session.timestamp,
          durationMilliseconds: milliseconds,
          duration: minutes + ":" + ('00' + seconds).slice(-2)
        }
      })
    },

    interactionPages () {
      const uniquePages = _.uniqBy(this.interactions, 'pageUrl')

      return uniquePages.map(page => {
        return {
          ...page,
          hitCounter: this.groupByPageId[page.pageUrl].length,
          label: this.getLabelFromUrl(page.pageUrl)
        }
      })
    }
  },

  watch: {
    heatStart (newDate) {
      if (newDate && this.heatEnd) {
        this.isShowingRange = true

        axios.get(`${process.env.VUE_APP_API_URL}interactions/datetime/${this.convertDateToTimestamp(this.heatStart)}/${this.convertDateToTimestamp(this.heatEnd)}`).then(res => {
          this.interactions = res.data
        })
      } else {
        if (this.isShowingRange) {
          this.isShowingRange = false

          // axios.get(process.env.VUE_APP_API_URL + 'interactions').then(res => {
          //   this.interactions = res.data
          // })
        }
      }
    },

    heatEnd (newDate) {
      if (newDate && this.heatStart) {
        this.isShowingRange = true

        axios.get(`${process.env.VUE_APP_API_URL}interactions/datetime/${this.convertDateToTimestamp(this.heatStart)}/${this.convertDateToTimestamp(this.heatEnd)}`).then(res => {
          this.interactions = res.data
        })
      } else {
        if (this.isShowingRange) {
          this.isShowingRange = false

          // axios.get(process.env.VUE_APP_API_URL + 'interactions').then(res => {
          //   this.interactions = res.data
          // })
        }
      }
    }
  },

  async created () {
    // axios.get(process.env.VUE_APP_API_URL + 'interactions').then(res => {
    //   this.interactions = res.data
    // })

    await this.$store.dispatch('fetchPages')
    await this.$store.dispatch('FETCH_LIVING_OPTIONS')
    await this.$store.dispatch('FETCH_SUBSECTIONS')
    await this.$store.dispatch('FETCH_PACKAGES')
    await this.$store.dispatch('FETCH_PROPERTIES')
    await this.$store.dispatch('fetchNavigation')

    const now =  moment().add(1, 'days').utcOffset('+09:30').format('YYYY-MM-DD')
    const lastMonth = moment().subtract(1, 'months').utcOffset('+09:30').format('YYYY-MM-DD')

    this.heatStart = lastMonth
    this.heatEnd = now    
  },

  mounted () {
    setTimeout(() => {
      this.isReady = true
    }, 1000)
  },

  methods: {
    convertDateToTimestamp (date) {
      return moment(date).utcOffset('+09:30').format('x')
    },

    getLabelFromUrl (url) {
      const newurl = new URL(process.env.VUE_APP_STAGING_HOST.slice(0, -1) + url)

      if (url === '/') { return 'Rest Screen' }

      const indexPage = url.indexOf('page')
      const indexLive = url.indexOf('live')
      const indexLand = url.indexOf('land')
      const indexProperty = url.indexOf('property')
      const indexPackages = url.indexOf('packages')
      const indexFavourites = url.indexOf('favourites')

      const activeSubsectionId = newurl.searchParams.get('activeSubsectionId')

      // is normal page
      if (indexPage > 0) {
        const pageId = url.slice(indexPage + 5, url.length)
        let pageLabel

        // loop over navigation items & build label
        this.navigation.categories[0].children.forEach(bottomBar => {
          let bottomBarLabel = bottomBar.label.en

          if (bottomBar.pageId === pageId) {
            pageLabel = bottomBarLabel
          }

          bottomBar.children.forEach(subBottomBar => {
            if (subBottomBar.pageId === pageId) {
              pageLabel = bottomBarLabel + ' / ' + subBottomBar.label.en
            }
          })
        }) 

        return pageLabel
      }

      // is live page - build label
      if (indexLive > 0) {
        let liveLabel = 'Live'

        if (indexLand > 0) {
          liveLabel += ' / Land'

          const livingOptionId = url.slice(indexLand + 5, url.length)
          const livingOption = this.livingOptions.find(livingOption => livingOption._id !== livingOptionId)

          if (livingOption) {
            liveLabel += ' / ' + this.stripHTMLTags(livingOption.label)

            if (activeSubsectionId) {
              const subsection = this.subsections.find(subsection => subsection._id === activeSubsectionId)

              if (subsection) {
                liveLabel += ' / ' + subsection.label
              }
            }

            if (indexProperty > 0) {
              const propertyId = url.slice(indexProperty + 9, indexProperty + 33)              
              const property = this.properties.find(property => property._id === propertyId)

              if (property) {
                liveLabel += ' / ' + property.label
              }
            }
          }
        }

        if (indexPackages > 0) {
          liveLabel += ' / Packages'
        }

        return liveLabel
      }

      // is favourites
      if (indexFavourites > 0) {
        let favouritesLabel = 'Favourites'

        const favouritesPropertyId = newurl.pathname.split('/')[4]
        if (favouritesPropertyId) {
          // find favourite in properties & packages
          const property = this.properties.find(property => property._id === favouritesPropertyId)
          const _package = this.packages.find(_packages => _packages._id === favouritesPropertyId)

          if (property) {
            favouritesLabel += ' / ' + property.label
          }

          if (_package) {
            favouritesLabel += ' / ' + _package.label
          }
        }

        return favouritesLabel
      }

      return url
    },

    play (interaction) {
      window.open(process.env.VUE_APP_STAGING_HOST + '?sessionId=' + interaction.sessionId, '_blank')
    },

    stripHTMLTags (string) {
      let regex = /(<([^>]+)>)/ig
      return string.replace(regex, '')
    },

    view (interaction) {
      let dateRange = ''
      if (this.heatStart && this.heatEnd) {
        dateRange += `&heatStart=${this.convertDateToTimestamp(this.heatStart)}&heatEnd=${this.convertDateToTimestamp(this.heatEnd)}`
      }
      
      const pageUrl = interaction.pageUrl.substring(1)
      if (pageUrl.match(/\?./)) {
        window.open(`${process.env.VUE_APP_STAGING_HOST}${pageUrl}&showHeat=true${dateRange}`, '_blank')
      } else {
        window.open(`${process.env.VUE_APP_STAGING_HOST}${pageUrl}?showHeat=true${dateRange}`, '_blank')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.table-wrapper {
  overflow: auto;
}

.date-range {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}
</style>
